import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { ezsServiceIds } from "../config/UserServicesList";

export function useAreServicesAvailable(serviceIds: any) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );

    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find((service: { serviceCode: any }) => service.serviceCode === id);
            if (service && service.serviceCode === id) {
                return true;
            }
        }
    }

    return false;
}

export function useAreServicesActive(serviceIds: any) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );
    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find(
                (service: { serviceCode: any }) => !!service.serviceCode && !!id && service.serviceCode.trim().toLowerCase() === id.trim().toLowerCase()
            );
            if (Boolean(service) && service.active) {
                return true;
            }
        }
    }

    return false;
}

export function getActiveServiceCode(serviceIds: any) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );
    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find((service: { serviceCode: any }) => service.serviceCode === id);
            if (service && service.serviceCode === id && service.active) {
                return service.serviceCode;
            }
        }
    }

    return null;
}

export function useCheckAnyServiceActive() {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser
            ? state.loggedInUser.userServiceDetails
                ? state.loggedInUser.userServiceDetails.userServices?.filter((service: any) => service.active)
                : initiaArray
            : initiaArray
    );
    if (userServices && userServices.length > 0) {
        return true;
    }

    return false;
}

export function useAreServicesAndFeatureActive(serviceIds: any, featureKeys: string[]) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );

    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find((service: { serviceCode: any }) => service.serviceCode === id);
            if (service && service.active) {
                if (isEZSUserService(service.serviceCode) && service.serviceFeatures) {
                    for (const featureKey of featureKeys) {
                        const feature = service.serviceFeatures.find((f: { key: string }) => f.key === featureKey);
                        if (feature && feature.key === featureKey && feature.value && feature.value.toLowerCase() === "true") {
                            return true;
                        }
                    }
                } else {
                    return true;
                }
            }
        }
    }

    return false;
}

export function useDoesServiceHaveUpgrades(serviceIds: any) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );

    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find((service: { serviceCode: any }) => service.serviceCode === id);
            if (service && service.serviceCode === id && service.active === false && service.availableForPurchase === true) {
                return true;
            }
        }
    }

    return false;
}

export function useIsFeatureAvailable(serviceIds: any, featureKey: string) {
    const initiaArray: any = [];
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : initiaArray) : initiaArray
    );

    if (userServices && userServices.length > 0) {
        for (const id of serviceIds) {
            const service = userServices.find((service: { serviceCode: any }) => service.serviceCode === id);
            if (service && service.serviceFeatures) {
                const feature = service.serviceFeatures.find((f: { key: string }) => f.key === featureKey);
                if (feature && feature.key === featureKey) {
                    return true;
                }
            }
        }
    }

    return false;
}

export function useDoesPartnerAllowUpgrades() {
    const configuration = useSelector((state: ApplicationState) => (state.configurationState ? state.configurationState.configuration : null));

    if (configuration) {
        const partnerConfig = configuration.partnerConfig;
        if (partnerConfig && partnerConfig.allowPackageUpgrade === true) {
            return true;
        }
    }

    return false;
}

export function useResourceTabPermission(isFeatureEnabled?: boolean) {
    const productFeatureOfBIDR = useSelector((state: ApplicationState) => state.productFeatureState?.productFeatureData);
    const isUpgradeAllowed = useDoesPartnerAllowUpgrades();
    const isEnrolledInBIDRservice = useAreServicesActive([ezsServiceIds.businessIdRestorationPro]);

    if (isFeatureEnabled && productFeatureOfBIDR && productFeatureOfBIDR.IsBIRDActive) {
        return (isUpgradeAllowed && isEnrolledInBIDRservice) || (!isUpgradeAllowed && isEnrolledInBIDRservice) || (isUpgradeAllowed && !isEnrolledInBIDRservice);
    }

    return false;
}

export function isEZSUserService(serviceId: string): boolean {
    const ServiceId = getKeyByValue(ezsServiceIds, serviceId);
    if (ServiceId) {
        return true;
    }

    return false;
}

function getKeyByValue(object: any, value: any) {
    return Object.keys(object).find((key) => object[key] === value);
}
